import TopUtilityBar from "../sections/TopUtilityBar";
import MainHeader from "../sections/MainHeader";
import Hero from "../sections/Hero";
import TrustStrip from "../sections/TrustStrip";
import CategoryTiles from "../sections/CategoryTiles";
import FeaturedDrop from "../sections/FeaturedDrop";
import CommunityLoadouts from "../sections/CommunityLoadouts";
import InstagramFeed from "../sections/InstagramFeed";
import BestsellersGrid from "../sections/BestsellersGrid";
import InStockTeaser from "../sections/InStockTeaser";
import AssemblyStrip from "../sections/AssemblyStrip";
import FinalTrustBand from "../sections/FinalTrustBand";
import WarrantyStrip from "../sections/WarrantyStrip";
import Footer from "../sections/Footer";
import { HOME } from "../constants/testIds";
import { useCanonical, useSeoMeta } from "../lib/seo";

// Loadout homepage. PROMPT 3.3M section order:
// 01 Bestsellers → 02 Armory → 03 Community → 04 Operator Lab → Warranty.
export default function HomePage() {
  useCanonical("/");
  useSeoMeta({ path: "/" });
  // Organization + WebSite JSON-LD are static in public/index.html.
  return (
    <div className="min-h-screen bg-white text-[#0A0A0A]">
      <TopUtilityBar />
      <MainHeader cartCount={0} />
      <Hero />
      <TrustStrip />
      <BestsellersGrid />
      <CategoryTiles />
      <FeaturedDrop />

      {/* SURFACE A — Configurator entry strip (PROMPT 3.2 §A). */}
      <section className="bg-white border-t border-b border-[#EAEAEA] py-6 md:py-8">
        <div className="mx-auto max-w-[1440px] px-6 flex flex-col md:flex-row items-start md:items-center justify-between gap-3">
          <div>
            <p className="font-mono text-[11px] tracking-[0.18em] uppercase text-[#8A8A8A]">
              Not sure where to start?
            </p>
            <p className="mt-1 font-display text-[22px] md:text-[26px] leading-tight text-[#0A0A0A] uppercase">
              Let us build a Loadout for you in 60 seconds.
            </p>
          </div>
          <a
            href="/build-my-loadout"
            data-testid={HOME.quizOpenHero}
            className="touch-target inline-block border border-[#0A0A0A] bg-[#0A0A0A] text-white font-mono text-[12px] tracking-[0.18em] uppercase px-6 py-4 hover:bg-[#FF9F1C] hover:border-[#FF9F1C] hover:text-black transition-colors"
            style={{ minHeight: 48 }}
          >
            Build My Loadout →
          </a>
        </div>
      </section>

      <CommunityLoadouts />
      <InstagramFeed />
      <InStockTeaser />
      <AssemblyStrip />
      <FinalTrustBand />
      <WarrantyStrip />
      <Footer />
    </div>
  );
}
